import http from "../http-common";

class GoldenDataService {

  getAll() {
    return http.get("/golden");
  }

  get(id) {
    return http.get(`/golden/${id}`);
  }

  create(data) {
    return http.post("/golden", data);
  }

  update(id, data) {
    return http.put(`/golden/questions/${id}`, data);
  }

  delete(id) {
    return http.delete(`/golden/${id}`);
  }

  deleteAll(id) {
    return http.delete(`/golden/${id}`);
  }

}

export default new GoldenDataService();